import UserProfileForm from "./user-profile-form";


export default UserProfileForm;